import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import frFR from './locales/fr-FR'
import esES from './locales/es-ES'
import itIT from './locales/it-IT'
import ptBR from './locales/pt-BR'
import nlNL from './locales/nl-NL'
import ruRU from './locales/ru-RU'
import plPL from './locales/pl-PL'
import svSE from './locales/sv-SE'

const savedLocale = typeof localStorage !== 'undefined'
  ? localStorage.getItem('locale') || ''
  : ''

function detectLocale(): string {
  if (savedLocale) return savedLocale
  const nav = typeof navigator !== 'undefined' ? navigator.language : ''
  if (nav.startsWith('zh')) return 'zh-CN'
  if (nav.startsWith('en')) return 'en-US'
  if (nav.startsWith('fr')) return 'fr-FR'
  if (nav.startsWith('es')) return 'es-ES'
  if (nav.startsWith('it')) return 'it-IT'
  if (nav.startsWith('pt')) return 'pt-BR'
  if (nav.startsWith('nl')) return 'nl-NL'
  if (nav.startsWith('ru')) return 'ru-RU'
  if (nav.startsWith('pl')) return 'pl-PL'
  if (nav.startsWith('sv')) return 'sv-SE'
  return 'zh-CN'
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'fr-FR': frFR,
    'es-ES': esES,
    'it-IT': itIT,
    'pt-BR': ptBR,
    'nl-NL': nlNL,
    'ru-RU': ruRU,
    'pl-PL': plPL,
    'sv-SE': svSE,
  },
})

export default i18n
